export const discord = "https://discord.gg/mycelium-xyz";
export const medium = "https://mycelium-xyz.medium.com";
export const docs = "https://docs.mycelium.xyz";
export const swapsDocs = "https://swaps.docs.mycelium.xyz";
export const swapsEarnDocs = "https://swaps.docs.mycelium.xyz/perpetual-swaps/information-for-lps";
export const poolsDocs = "https://pools.docs.mycelium.xyz";
export const migration = "https://migrate.mycelium.xyz";
export const pools = "https://pools.mycelium.xyz";
export const staking = "https://stake.mycelium.xyz";
export const twitter = "https://twitter.com/mycelium_xyz";
export const github = "https://github.com/mycelium-ethereum";
export const youtube = "https://www.youtube.com/channel/UCX5iO1iHlwUTmS0kSsDk6DA";
